export default {

    getStatusTypesList() {
        return [
            {value: "regel", label: "Schule"},
            {value: "kiga", label: "Kiga"},
            {value: "vors", label: "Vorschule"},
            {value: "inso", label: "InSo"},
            {value: "sek1", label: "Sek I"},
            {value: "sek2", label: "Sek II"},
        ];
    },

    getBillableCategoryTypes() {
        return {
            label: 'Berechenbar',
            options: [
                //----- A.m.K. billable types -------
                {value: "b_th", label: "Therapien"},
                {value: "b_ab", label: "Abklärungen"},
                {value: "b_ko", label: "Kontrollen"},
                {value: "b_bk", label: "Beratungen mit Kind"},
                {value: "b_ak", label: "Ausfall Kind"},
                {value: "b_kr", label: "Krankheit"},
                {value: "b_sr", label: "Screening / Reihe"},
                {value: "b_fe", label: "Fernunterricht"},
                {value: "b_di", label: "Diverses A.m.K."},
                {value: "b_pa", label: "Pause"},
                {value: "b_as", label: "Abschluss"},
                {value: "b_be", label: "Beginn"},
                {value: "b_wi", label: "Wiederaufnahme"},
                //----- additional billable types -------
                {value: "b_vn", label: "Vor- / Nachbereitung"},
                {value: "b_db", label: "Diverses berechenbar"},//new
                {value: "b_ge", label: "Gespräche"},//new
            ]
        };
    },

    getNonBillableCategoryTypes() {
        return {
            label: 'Nicht Berechenbar',
            options: [
                {value: "n_wb", label: "Weiterbildungen"},
                {value: "n_sk", label: "Sitzungen"},
                {value: "n_ae", label: "Ämtli"},
                {value: "n_se", label: "Schulentwicklung"},
                {value: "n_ag", label: "Arbeitsgruppen"},
                {value: "n_ko", label: "Konvente"},
                {value: "n_ad", label: "Administration"},
                {value: "n_so", label: "Sonstiges"},
            ]
        };
    },

    getDualCategoryTypes() {
        return {
            label: 'Ferien',
            options: [
                {value: "d_fu", label: "Ferien"},
            ]
        };
    },

    getAllSelectOption() {
        return {
            label: 'Alle Kategorien',
            options: [
                {value: "all", label: "Alle Kategorien"},
            ]
        };
    },

    getAllCategoryTypes() {
        return [
            this.getBillableCategoryTypes(),
            this.getNonBillableCategoryTypes(),
            this.getDualCategoryTypes(),
        ]
    },

    getBillableAndDualCategoryTypes() {
        return [
            this.getBillableCategoryTypes(),
            this.getDualCategoryTypes(),
        ]
    },

    getNonBillableAndDualCategoryTypes() {
        return [
            this.getNonBillableCategoryTypes(),
            this.getDualCategoryTypes(),
        ]
    },


    /*
    ** FOR REPORT MODULE ONLY
     */
    getAllCategoryTypesPlusAllSelector() {
        return [
            this.getAllSelectOption(),
            this.getBillableCategoryTypes(),
            this.getNonBillableCategoryTypes(),
            this.getDualCategoryTypes(),
        ]
    },

    getStatusTypesListPlusAllSelector() {
        let array = this.getStatusTypesList()
        array.push({value: "all", label: "Alle Status"})
        return array;
    }
}